// デザインボード：画面デザイン（.pen / OpenPencil）と業務フローボード（Excalidraw）。doc/design/pm-design-board-screens.html
export default {
  "design.tab": "設計",
  "design.page.entry": "設計（白板 / .pen）",
  "design.page.title": "設計",
  "design.page.titleOf": "{name} · 設計",
  "design.page.subtitle":
    "用截圖、便籤和箭頭梳理流程，並與 .pen 原稿一起做版本管理和審查",
  "design.page.new": "新增",
  "design.page.filteredByTask": "僅顯示任務「{name}」的設計",
  "design.page.showAll": "顯示全部",
  "design.empty": "還沒有設計",
  "design.untitled": "未命名業務流程板",
  "design.back": "返回列表",
  "design.more": "更多",
  "design.retry": "重試",
  "design.saved": "已儲存為 v{rev}",
  "design.col.title": "標題",
  "design.col.format": "類型",
  "design.col.task": "關聯任務",
  "design.col.revision": "版本",
  "design.col.updated": "更新",
  "design.format.excalidraw": "業務流程",
  "design.format.pen": "畫面設計",
  "design.deleteConfirm": "確定刪除「{title}」？",
  "design.deleteHint": "所有版本和審查留言將從列表中移除。",
  "design.edit.title": "編輯設計",
  "design.edit.taskHint": "留空則作為整個專案的設計。",
  "design.field.title": "標題",
  "design.field.titlePlaceholder": "留空則使用「未命名白板」或檔名",
  "design.field.task": "關聯任務",
  "design.field.note": "變更說明",
  "design.create.title": "建立設計",
  "design.create.ok": "建立",
  "design.create.mode": "建立方式",
  "design.create.blank": "空白板",
  "design.create.file": "從 .excalidraw 檔案匯入",
  "design.file.drop": "拖放檔案，或點擊選擇",
  "design.file.hint": ".excalidraw · 最大 {mb}MB（含圖片）",
  "design.file.need": "請選擇檔案",
  "design.source.title": "Git 來源（選填）",
  "design.source.hint":
    "記錄檔案在 Git 中的位置。請勿填寫憑證（含權杖的 URL）。不會自動 pull / push。",
  "design.source.repo": "儲存庫",
  "design.source.ref": "分支 / ref",
  "design.source.path": "儲存庫內路徑",
  "design.source.commitSha": "提交 SHA",
  "design.upload.menu": "上傳新版本",
  "design.upload.title": "上傳新版本（v{rev}）",
  "design.upload.ok": "匯入",
  "design.export.file": "匯出檔案",
  "design.export.manifest": "匯出中繼資料（.design.json）",
  "design.status.dirty": "未儲存",
  "design.status.saving": "儲存中…",
  "design.status.saved": "已儲存",
  "design.status.error": "儲存失敗",
  "design.leave.title": "有未儲存的變更",
  "design.leave.content": "現在離開將遺失未儲存的變更。",
  "design.leave.ok": "捨棄並離開",
  "design.conflict.title": "其他人先儲存了",
  "design.conflict.content":
    "你的變更仍保留在畫面上。載入最新版本會捨棄你的變更。如有需要，請先另存為新設計或下載草稿。",
  "design.conflict.reload": "載入最新（捨棄我的變更）",
  "design.conflict.keep": "返回編輯",
  "design.conflict.saveAsCopy": "將我的變更另存為新設計",
  "design.conflict.copyTitle": "{title}（衝突副本）",
  "design.conflict.download": "下載草稿（.excalidraw）",
  "design.history.banner": "正在檢視 v{rev}（唯讀，最新為 v{latest}）",
  "design.history.latest": "回到最新",
  "design.history.restore": "從此版本還原",
  "design.restore.note": "從 v{rev} 還原",
  "design.pen.limitTitle": "暫不支援在瀏覽器中檢視和編輯 .pen",
  "design.pen.limitBody":
    "原始檔會按位元組原樣儲存和匯出。OpenPencil 原生畫布的嵌入與無損回寫尚未驗證，因此暫不提供。請依下列步驟編輯。",
  "design.pen.file": "檔名",
  "design.pen.size": "大小",
  "design.pen.download": "下載 .pen",
  "design.pen.step1": "點擊「下載 .pen」取得原始檔",
  "design.pen.step2": "用 OpenPencil 等支援 .pen 的工具開啟並編輯儲存",
  "design.pen.step3":
    "透過「從檔案匯入新版本」上傳（若他人已推進版本則會被拒絕）",
  "design.comment.title": "審查",
  "design.comment.scopeRev": "v{rev}",
  "design.comment.scopeAll": "全部版本",
  "design.comment.none": "還沒有留言",
  "design.comment.loadFailed": "無法載入留言",
  "design.comment.placeholder": "留言 v{rev}",
  "design.comment.post": "發表留言",
  "design.comment.empty": "請輸入留言",
  "design.comment.resolved": "已解決",
  "design.comment.resolvedBy": "{name} 已解決",
  "design.comment.deleteConfirm": "確定刪除這則留言？",
  "design.task.openList": "開啟設計板",
  "design.error.load": "無法載入設計",
  "design.error.notFound": "找不到設計（已刪除或無權存取）",
  "design.error.parse": "無法將已儲存內容讀取為白板。為防止覆蓋，已禁止編輯。",
  "design.error.save": "儲存失敗",
  "design.error.network": "無法連線伺服器。你的變更仍保留在畫面上。",
  "design.error.size": "資料過大（含圖片最多 10MB）。請縮小圖片或減少數量",
  "design.error.elements": "元素過多（最多 5000 個）",
  "design.error.embeddable": "網頁嵌入元素無法儲存。請刪除後再儲存",
  "design.error.image-missing": "圖片資料遺失。請重新貼上圖片後儲存",
  "design.error.image-type": "不支援此圖片格式（僅 PNG / JPEG / GIF / WebP）",
  "design.error.image-size": "圖片過大（每張最多 5MB）",
  "design.error.type": "請選擇 .excalidraw 或 .pen 檔案",
  "design.error.format": "檔案類型與此設計不一致",
  "design.close": "關閉",
  "design.frame.status.draft": "草稿",
  "design.frame.status.review": "待審查",
  "design.frame.status.changes": "需修改",
  "design.frame.status.approved": "已核准",
  "design.frame.list": "畫面列表",
  "design.frame.panel": "任務・審查",
  "design.frame.search": "搜尋畫面",
  "design.frame.collapse": "收合畫面列表",
  "design.frame.expand": "展開畫面列表",
  "design.frame.none": "沒有畫面（頂層畫框）",
  "design.frame.reviewStatus": "審查狀態",
  "design.frame.tasks": "關聯任務",
  "design.frame.unlink": "取消關聯",
  "design.frame.linkTask": "＋ 關聯任務",
  "design.frame.notInLatest":
    "此畫面不在最新版本中（審查狀態與任務只能加在最新版本的畫面上）",
  "design.frame.removed": "最新版已刪除",
  "design.pen.historyBanner":
    "正在檢視 v{rev}（最新為 v{latest}）。審查狀態與任務為目前的值",
  "design.pen.missingFonts": "部分字型無法載入，已用替代字型顯示：{fonts}",
  "design.pen.viewerError": "無法顯示此 .pen",
  "design.pen.loading": "正在用 OpenPencil 載入…",
  "design.pen.selectHint":
    "點擊畫面即可設定審查狀態、任務與留言。.pen 請在 Pencil 中編輯後「上傳新版本」",
  "design.pen.uploaded": "已上傳 v{rev}",
  "design.board.frames": "畫面 {n}",
  "design.board.filter.all": "全部",
  "design.board.newPen": "畫面設計（.pen）",
  "design.board.newPenHint": "上傳 .pen，用 OpenPencil 檢視與審查",
  "design.board.newFlow": "業務流程板",
  "design.board.newFlowHint": "用畫面、便利貼與箭頭畫業務流程（Excalidraw）",
  "design.board.empty": "還沒有設計板。請從「新增」上傳 .pen 或建立業務流程板",
  "design.create.penTitle": "上傳畫面設計（.pen）",
  "design.create.boardTitle": "建立業務流程板",
  "design.create.penHint":
    "原樣保存 Pencil 製作的 .pen，並用 OpenPencil 顯示（不支援在瀏覽器中編輯 .pen）",
  "design.file.hintPen": ".pen · 最大 {mb}MB",
  "design.flow.add": "新增畫面",
  "design.flow.addTitle": "向流程板新增畫面",
  "design.flow.addOk": "新增 {n} 個",
  "design.flow.pickNeed": "請選擇要新增的畫面",
  "design.flow.pickAll": "全選",
  "design.flow.renderFailed": "無法匯出畫面圖片。",
  "design.flow.noPen": "本專案還沒有畫面設計（.pen）",
  "design.flow.renderHint":
    "圖片由瀏覽器中的 OpenPencil 匯出。審查狀態與任務與畫面設計共用",
  "design.flow.added": "已新增 {n} 個畫面（儲存後生效）",
  "design.flow.refreshed": "已更新為 v{rev} 的圖片（儲存後生效）",
  "design.flow.source": "來源：{design} · v{rev}",
  "design.flow.outdated": "畫面設計有新版本 v{rev}",
  "design.flow.refresh": "更新為 v{rev}",
  "design.flow.frameGone": "找不到來源畫面（可能已被刪除）",
  "design.flow.shared": "與畫面設計共用",
  "design.flow.openDesign": "在畫面設計中開啟",
  "design.task.empty": "沒有關聯到此任務的畫面或流程板",
};
